// LDT-706 (épica LDT-698) · Qué textos legales acepta el PARQUE al contratar
// Playium. Una sola lista para el cliente y el servidor: el checkout de la
// landing (`CheckoutModal`), los diálogos de renovar y comprar del panel
// (`BillingPanel`) y el alta manual del superadmin (`CreateLocalDialog`) pintan
// sus casillas con ella, y `billing-checkout` y `create-local` exigen justo
// eso (`venue-legal.ts`). Si la pantalla enseñara un documento más o uno menos
// de lo que el servidor exige, `checkDisplayed` respondería `missing` a todas
// las altas; lo sostiene `src/test/aceptacion-alta-parque.test.tsx`.
//
// Sin ningún import: lo carga la landing y no debe arrastrar código de Deno.
//
// Modelo Docket, dos casillas SIN marcar (decisión de David, 2026-09-28):
//   1. Contrato como empresa o profesional (Playium es solo B2B) y acepto las
//      Condiciones, la política de cancelaciones y reembolsos, el Contrato de
//      encargo del tratamiento (DPA) y la lista de subencargados.
//   2. He leído la Política de privacidad, la de cookies y el aviso legal.
//
// `refunds` va en la 1: es contrato (qué pasa con el dinero al cancelar), no
// información. Ya se enlazaba en el checkout antes de LDT-706.
//
// Las claves son las de `LEGAL_DOCS` (src/config/legal.ts) y las de
// `LEGAL_DOC_VERSIONS` (_shared/legal-acceptance.ts); el test lo comprueba.

/** Casilla 1: lo que se ACEPTA (contrato), con la declaración B2B. */
export const VENUE_CONTRACT_DOCS = ["terms", "refunds", "dpa", "subprocessors"] as const;

/** Casilla 2: lo que se declara HABER LEÍDO (información). */
export const VENUE_POLICY_DOCS = ["privacy", "cookies", "legalNotice"] as const;

/** Alta self-serve y renovación o compra desde el panel: las dos casillas. */
export const VENUE_CHECKOUT_DOCS = [...VENUE_CONTRACT_DOCS, ...VENUE_POLICY_DOCS] as const;

/**
 * Alta manual por el superadmin: declara que el cliente firmó o aceptó por
 * otra vía (contrato SEPA en papel) las condiciones, el DPA y la lista de
 * subencargados: lo que LDT-706 pide para esta vía. Sin reembolsos ni los
 * textos de la casilla 2, que el superadmin no puede declarar por el cliente.
 */
export const VENUE_ATTESTATION_DOCS = ["terms", "dpa", "subprocessors"] as const;
